import { DateTime } from 'luxon';

export const TRPC_PROXY_TIMEOUT_SECONDS = 100;

export const FLIGHT_NUMBER_REGEX = /^[A-Z0-9]{2,3}\d{1,4}$/i;

/**
 * AeroDataBox rejects dates at exactly 180 days in the past and in the future, so the
 * usable limit is 179.
 */
export const AERODATABOX_MAX_DAYS = 179;

/** Google Travel Impact Model only supports flight data from 2019 onwards. */
export function getFlightCalculatorStandardMinDate() {
  return DateTime.fromObject({ year: 2019, month: 1, day: 1 });
}

/**
 * Google TIM supports data up to the current calendar year. We allow year+1 in the UI
 * and substitute it with the current year on the backend before calling the API.
 */
export function getFlightCalculatorStandardMaxDate() {
  return DateTime.fromObject({ year: DateTime.now().year + 1, month: 12, day: 31 });
}

export function getFlightCalculatorAdvancedMinDate() {
  return DateTime.now().minus({ days: AERODATABOX_MAX_DAYS }).startOf('day');
}

export function getFlightCalculatorAdvancedMaxDate() {
  return DateTime.now().plus({ days: AERODATABOX_MAX_DAYS }).startOf('day');
}

export const FLIGHT_CHECKOUT_MAX_ITEMS = 50;
